import { useCallback } from "react";

import * as Repository from "../repository";

import type * as DiscountItemOrdinaryShared from "../../../_shared";

type Props = {
	inputModel: DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"];
	onResetViewModel: () => void;
};

export const useUpdateDiscountLongTerm = ({ inputModel, onResetViewModel }: Props) => {
	const { onUpdateDiscountLongTerm: _onUpdateDiscountLongTerm } =
		Repository.Mutation.useDiscountLongTermUpdateMutation({ onResetViewModel });

	const onUpdateDiscountLongTerm = useCallback(
		() => _onUpdateDiscountLongTerm(inputModel),
		[_onUpdateDiscountLongTerm, inputModel],
	);

	return {
		onUpdateDiscountLongTerm,
	};
};
